import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "" || name === "" || password === "") {
      return;
    }

    fetch(
      "https://shreyas-dobby-backend-production.up.railway.app/api/auth/signup",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          name: name,
          password: password,
        }),
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        navigate("/login");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="flex justify-center flex-col p-10 items-center">
      <h1 className="my-4 text-4xl font-bold">Signup</h1>
      <form>
        <div className="flex flex-col p-6 bg-gray-400 rounded-md">
          <p className="my-2">Name</p>
          <input
            type="text"
            name="name"
            placeholder="name"
            className="rounded-sm p-2 outline-none"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <p className="my-2">E-mail</p>
          <input
            type="email"
            name="email"
            placeholder="email"
            className="rounded-sm p-2 outline-none"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <p className="my-2">Password</p>
          <input
            type="password"
            name="password"
            placeholder="email"
            className="rounded-sm p-2 outline-none"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <button
            type="submit"
            onClick={handleSubmit}
            className="mt-10 bg-green-700 p-3 rounded-md hover:opacity-70 transition-all 
            duration-300 ease-in"
          >
            Signup
          </button>
        </div>
      </form>
      <div className="mt-10">
        <p className="">
          <Link to="/login" className="">
            Already a user? Login Now
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
